import { render } from "./PurchaseModal.vue?vue&type=template&id=16713474&scoped=true"
import script from "./PurchaseModal.vue?vue&type=script&lang=js"
export * from "./PurchaseModal.vue?vue&type=script&lang=js"

import "./PurchaseModal.vue?vue&type=style&index=0&id=16713474&lang=stylus&scoped=true"
import "./PurchaseModal.vue?vue&type=style&index=1&id=16713474&lang=stylus"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16713474"]])

export default __exports__